import { useState } from "react";

// A textarea with an inline "AI draft" affordance. Clicking Draft sends the
// field label, current text and project context to /api/draft-field and
// replaces the text with the model's improved passage.
export function AiTextArea({
  value,
  onChange,
  label,
  context,
  placeholder,
  rows,
}: {
  value: string;
  onChange: (v: string) => void;
  label: string;
  context: unknown;
  placeholder?: string;
  rows?: number;
}) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [instr, setInstr] = useState("");
  const [showInstr, setShowInstr] = useState(false);

  async function draft() {
    setBusy(true);
    setErr(null);
    try {
      const res = await fetch("/api/draft-field", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ label, current: value, instruction: instr, context }),
      });
      if (!res.ok) throw new Error((await res.text()) || `HTTP ${res.status}`);
      const data = (await res.json()) as { text?: string };
      if (data.text) onChange(data.text);
      setInstr("");
      setShowInstr(false);
    } catch (e: any) {
      setErr(`AI unavailable (${String(e.message).slice(0, 80)})`);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="aita">
      <textarea value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} rows={rows} />
      <div className="aita-bar">
        <button type="button" className="aita-btn" onClick={draft} disabled={busy} title="Draft this field with AI">
          {busy ? <span className="spinner dark-spin" /> : "✦ AI draft"}
        </button>
        <button type="button" className="aita-btn ghost" onClick={() => setShowInstr((s) => !s)} title="Add an instruction">
          {showInstr ? "− instruction" : "+ instruction"}
        </button>
        {err && <span className="aita-err">{err}</span>}
      </div>
      {showInstr && (
        <input
          className="aita-instr"
          value={instr}
          onChange={(e) => setInstr(e.target.value)}
          placeholder="Optional: how to draft it (e.g. 'make it stricter', 'add a 20% local-labour requirement')"
        />
      )}
    </div>
  );
}
